import react from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import usePrefersReducedMotion from '../hooks/usePrefersReducedMotion';
import { navDelay, loaderDelay } from '../utils/index';
import { CSSTransition, TransitionGroup } from 'react-transition-group';


const StyledHeroSection = styled.section`
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  height: 100vh;
  padding: 0;

  margin-top: 110px;

  @media (max-height: 700px) and (min-width: 700px), (max-width: 360px) {
    height: auto;
    padding-top: 100px;
  }

  h1 {
    margin: 0 0 30px 0;
    color: #64ffda;
    
    font-family:'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;
    ${'' /* font-size: clamp(14px, 5vw, 16px); */}
    font-weight: 400;
    line-height: 0.9;
    font-size: 16px;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h2{
    color: #ccd6f6;
    margin: 50px 0 13px 0;
    font-size: 82px;
    font-weight: 650;
    line-height: 0.9;
  }

  h3 {
    margin :0 0 0 0;
    color: #8892b0;
    font-size: 80px;
    font-weight: 650;
    line-height: 0.9;
  }

  p {
    margin: 35px 0 0 0  ;
    margin-right: 300px;
    max-width: 540px;
    color: #8892b0;
    font-size: 20px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }

`;


export default function Hero() {

    const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);


    const one = <h1>Hi, my name is</h1>;
    const two = <h2 className="big-heading">Jaimin Viramgama.</h2>;
    const three = <h3 className="big-heading">I build things for the web.</h3>;
    const four = (
        <>
        <p>
        I’m a Computer Science student, Software Developer and AI Enthusiast. I am passionate about building excellent software that improves the lives of those around me.
        </p>
        </>
    );
    const five = (
      <a
        className="email-link"
        href="https://github.com/i-apex?tab=repositories"
        target="_blank"
        rel="noreferrer">
        Check out my projects!
      </a>
    );
    const items = [one, two, three, four,five];

    return (

        <>  
        <StyledHeroSection>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </StyledHeroSection>
            {/* <h1>About</h1> */}
        </>
    );
}
